__turbopack_context__.v({
  "image": "G5I3XG_image",
  "slide": "G5I3XG_slide",
});
